import React, { Fragment, ReactNode } from "react";
import { useBooleanState } from "../../../hooks/utils";
import BugsOverviewModal from "../../molecules/modals/BugsOverviewModal";
import ChangePasswordModal from "../../molecules/modals/ChangePasswordModal";

interface LogoutSectionModalsReturnType {
  modals: ReactNode;
  setIsPasswordModalOpen: () => void;
  setIsBugsModalOpen: () => void;
}

const useLogOutSectionModals = (
  requestLogout: () => void
): LogoutSectionModalsReturnType => {
  const [isPasswordChangeModalOpen, setIsPasswordModalOpen] =
    useBooleanState(false);
  const [isBugsModalOpen, setIsBugsModalOpen] = useBooleanState(false);

  const modals = (
    <Fragment>
      <ChangePasswordModal
        isOpen={isPasswordChangeModalOpen}
        toggle={setIsPasswordModalOpen}
        logOut={requestLogout}
        userEmail=""
      />
      <BugsOverviewModal
        isModalOpen={isBugsModalOpen}
        toggleModal={setIsBugsModalOpen}
      />
    </Fragment>
  );

  return {
    modals,
    setIsPasswordModalOpen,
    setIsBugsModalOpen,
  };
};

export default useLogOutSectionModals;
